import Icon from 'components/Icon/Icon'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import Typography from 'components/Typography/Typography'

const AddVoucher = ({ onClick }) => {
    const intl = useIntl()

    const borderClass = 'add-tickets--border d-flex justify-content-center align-items-center'

    return (
        <Container fluid className={'add-tickets d-flex flex-column'}>
            <Typography variant={'h2'}>Přidat další vouchery</Typography>
            <div className="add-tickets--plus" role={'button'} onClick={onClick}>
                <div className={borderClass}>
                    <Icon name={'plus'} />
                </div>
                <div className={borderClass}>
                    <Typography variant={'p'}>Přidat další vouchery</Typography>
                </div>
            </div>
        </Container>
    )
}

export default AddVoucher
